import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
  NetSuiteClassList,
  NetSuiteCustomerList,
} from '../model/netSuiteWebClient.model';
import {
  GenerateInvoiceViewModel,
  INetSuiteInvoiceResponseModel,
  IPreviewNetSuiteInvoiceModel,
} from './generateInvoiceView.model';
import { QBCustomerClassList } from './vendorDetailView.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NetSuiteService {
  // todo need to refactor to remove isInvoiceGenerated, netSuiteCustomerList$, netSuiteCustomerClassList$
  isInvoiceGenerated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  netSuiteCustomerList$: BehaviorSubject<NetSuiteCustomerList[]> = new BehaviorSubject<NetSuiteCustomerList[]>(null);
  netSuiteCustomerClassList$: BehaviorSubject<QBCustomerClassList[]> = new BehaviorSubject<QBCustomerClassList[]>(null);

  constructor(private httpClient: HttpClient) {}

  getCustomerList(): Observable<NetSuiteCustomerList[]> {
    const url = `${environment.apiHost}/NetSuite/GetCustomerList`;

    return this.httpClient.get<NetSuiteCustomerList[]>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getClassList(): Observable<NetSuiteClassList[]> {
    const url = `${environment.apiHost}/NetSuite/GetClassList`;

    return this.httpClient.get<NetSuiteClassList[]>(url)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  netSuiteCreateInvoice(model: GenerateInvoiceViewModel, isTestInvoice: boolean): Observable<INetSuiteInvoiceResponseModel> {
    const url = `${environment.apiHost}/NetSuite/GenerateInvoice/${isTestInvoice}`;

    return this.httpClient.post<INetSuiteInvoiceResponseModel>(url, model)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  showNetSuiteInvoicePreview(model: GenerateInvoiceViewModel): Observable<IPreviewNetSuiteInvoiceModel> {
    const url = `${environment.apiHost}/NetSuite/InvoicePreview`;

    return this.httpClient.post<IPreviewNetSuiteInvoiceModel>(url, model)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  savePreviewInvoice(invoicePreviewData: IPreviewNetSuiteInvoiceModel): Observable<boolean> {
    const url = `${environment.apiHost}/NetSuite/SaveInvoicePreview`;

    return this.httpClient.post<boolean>(url, invoicePreviewData)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

}
